import React, { useState } from 'react'
import { NoNotificationIcon } from '../../../../shared/IconsComponent/icons';
import ActiveAlert from '../../../../General/ActiveAlert';
import isNull from '../../../../../utils/NullChecking';
import HTMLParser from '../../../../General/NotesTab/ParserHtml';
import Addalert from '../../../../General/AddAlert';

const AlertNotofications = (props) => {
    const { alertNotifications, OpenAlert } = { ...props }
    // const dispatch = useDispatch();
    // const API_URL = process.env.REACT_APP_API
    // // let conn = useSignalR(API_URL + "alertNotificationsHub", 'alertNotificationsHub').connection;
    // // useEffect(() => {
    // //     setConnection(conn);
    // // }, [conn]);
    // let isReconnectedToHub = useSelector(state => state.SignalRhubsReducer?.ReconnectingalertNotificationsHub)
    // let ConnectedalertNotificationsHub = useSelector(state => state.SignalRhubsReducer?.alertNotificationsHub)
    // const [TaskID, SetTaskID] = useState()
    // const [alertNotifications, setAlertNotifications] = useState([])
    // const [isConnected, setisConnected] = useState(false)
    // const [nofityMe, setNofityMe] = useState(false);

    // useEffect(() => {
    //     console.log('connection', connection)
    //     if (connection) {
    //         setisConnected(true)
    //         connection.on("ReceiveAlertNotification", (notifications) => {
    //             // setAlertNotifications(prevNotifi => [notifications, ...prevNotifi]);
    //             setNofityMe(true);
    //             setTimeout(() => {
    //                 setNofityMe(false);
    //             }, 1000);
    //         });
    //     }
    // }, [connection]);
    // useEffect(() => {
    //     if (connection) {
    //         connection.on("ReceiveUndelieveredAlertNotifications", (notifications) => {
    //             console.log('connection', notifications);
    //             try {
    //                 console.log('connection', notifications);

    //                 setAlertNotifications(notifications);
    //             } catch (error) {
    //                 console.error("Error in ReceiveUndelieveredAlertNotifications:", error);
    //             }
    //         });
    //     }
    // }, []);
    // useEffect(() => {
    //     if (connection) {
    //         dispatch(addSignalRConnection("taskNotificationsHub", connection));
    //     }
    // }, [dispatch]);
    // useEffect(() => {
    //     if (isReconnectedToHub && connection?.state === "Disconnected" && ConnectedalertNotificationsHub) {
    //         setConnection(ConnectedalertNotificationsHub)
    //         ConnectedalertNotificationsHub.on("ReceiveUndelieveredNotifications", (notifications) => {
    //             try {
    //                 // setAlertNotifications(notifications);
    //                 dispatch(isReconnected('taskNotificationsHub', false));
    //             } catch (error) {
    //                 // setAlertNotifications([]);
    //                 console.error("Error in ReceiveUndelieveredNotifications:", error);
    //             }
    //             // setMessages(prevMessages => [...prevMessages, newMessage]);
    //         });
    //     }
    // }, [isReconnectedToHub, ConnectedalertNotificationsHub])


    // const AcknowledgeAlert = (id, index) => {
    //     let data = [...alertNotifications]
    //     data.splice(index, 1);
    //     // setAlertNotifications(data)
    //     if (connection) {
    //         connection.invoke("AcknowledgeAlertNotification", id).catch((err) => console.error(err.toString()));
    //     }
    // }
    // const handleMarkAllAlert = () => {
    //     let token = store.getState();
    //     token = token.Login.token
    //     if (connection) {
    //         connection.invoke("AcknowledgeAllAlertNotification").catch((err) => console.error(err.toString()));
    //         // setAlertNotifications([])
    //     }
    // }



    // console.log('connection' , alertNotifications)
    // const [isAlertVisible, setAlertVisible] = useState(false);

    // const [AlertID, setAlertID] = useState()
    // const [AlertType, setAlertType] = useState()
    // const [AlertDisplay, setAlertDisplay] = useState()
    // const OpenAlert = (data) => {
    //     setAlertVisible(true)
    //     setAlertID(data.ID)
    //     setAlertType(data.Type)
    //     setAlertDisplay(data.Name)
    // }
    // const CloseCategory = () => {
    //     setAlertVisible(false)
    //     setAlertID(null)
    // }
    // let Alert
    // if (isAlertVisible && !isNull(AlertID)) {
    //     Alert = <Addalert isOpenAlertType={isAlertVisible} onClose={CloseCategory} Contains={AlertID} />
    //     // Alert = <ActiveAlert alertFrom={AlertType} ID={AlertID} display={`${AlertType} ${AlertDisplay}`} />
    // }
    return (
        <div>
            {/* {Alert} */}
            <div className="d-flex flex-column gap-10 px-10 scroll hover-scrollbar pb-2 px-10 ar_task-notification">
                {alertNotifications.length > 0 ?
                    alertNotifications.map((data, index) => {
                        return (
                            <div className={data.IsNotificationSeen === 'true' ? "ar-content-box light" : "ar-content-box"}>
                                <div className="d-flex align-items-center justify-content-between pb-1">
                                    <p className="text font-m ar-dark-color hover-heading" onClick={() => OpenAlert(data)}>   <HTMLParser htmlContent={data.AlertFor} /></p>
                                    {/* <p className="text fs-9 ar-dot ar-dark-color">{data.CreatedDate}</p> */}
                                    {/* <i className="icon-x-cros fs-16 dark-clr d-none" onClick={() => AcknowledgeAlert(data.AlertID, index)}></i> */}
                                </div>
                                <div>
                                    <div className="pb-1-5 br-bottom-1 za_br_light">
                                        <p className='ar-light-color text multiline-ellipsis pb-1'>{data.AlertDescription}</p>
                                        <p className='text fs-11 ar-light-color font-sb'>Expires on: {data.ExpiresOn ? data.ExpiresOn : 'N/A'}</p>

                                    </div>
                                    <div className="pt-1 d-flex align-items-center gap-6">
                                        <p className='text fs-11 ar-light-color font-m'>By, Date:</p>
                                        <p className='text fs-11 ar-light-color'>{data.CreatedBy} {data.CreatedDate}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    }) :
                    <div className="d-flex align-items-center justify-content-center flex-column gap-12 py-3 my-1">
                        <NoNotificationIcon classes={'fs-48'} />
                        {/* Task No Notification design  */}
                        <div className="text-center">
                            <p className='text fs-12 font-m'>No New Notifications!</p>
                            <p className='text fs-11 ar-ligh-color'>We’ll notify you once something comes up.</p>
                        </div>
                    </div>
                }
                {/* <div className="ar-content-box light">
                    <div className="d-flex align-items-center justify-content-between pb-1">
                        <p className="text font-m ar-dark-color hover-heading">Alert for Claim # 028323892</p>
                        <p className="text fs-9 ar-dot ar-dark-color">2025-03-25</p>
                        <i className="icon-x-cros fs-16 dark-clr d-none"></i>
                    </div>
                    <div>
                        <div className="pb-1-5 br-bottom-1 za_br_light">
                            <p className='ar-light-color text multiline-ellipsis'>Adding alert for HAZEL, SITES as a testing purpose for test whether its funsctional or not added...</p>
                        </div>
                        <div className="pt-1 d-flex align-items-center gap-6">
                            <p className='text fs-11 ar-light-color font-m'>By, Date:</p>
                            <p className='text fs-11 ar-light-color'>Lay Anderson, 1/13/2025 3:04 AM</p>
                        </div>
                    </div>
                </div> */}
            </div>

            {/* <div className="px-10 d-flex align-items-center justify-content-end ar-footer gap-1">
                <i className="bi bi-check-all fs-18"></i>
                <p className="text fs-11 cursor-pointer" onClick={() => handleMarkAllAlert()}>Mark All as read</p>
            </div> */}
        </div>
    )
}

export default AlertNotofications